import type { ReactNode } from 'react'

export type ResultGap = 40 | 60 | 70

const GAP_CLASS: Record<ResultGap, string> = {
  40: 'gap-10',
  60: 'gap-[60px]',
  70: 'gap-[70px]',
}

export function SubmitResultScreen({
  icon,
  title,
  titleWeight,
  description,
  gap,
  children,
}: {
  icon: ReactNode
  title: string
  titleWeight: 'semibold' | 'medium'
  description?: string | undefined
  gap: ResultGap
  children?: ReactNode
}) {
  return (
    <section
      className={`flex w-full flex-col ${GAP_CLASS[gap]} pt-[38px] md:mx-auto md:my-auto md:max-w-[343px] md:pt-0`}
    >
      <div className="flex items-start gap-2">
        <span className="flex shrink-0 items-center pt-1" aria-hidden="true">
          {icon}
        </span>
        <div className="flex min-w-0 flex-1 flex-col gap-0.5">
          <p
            className={`m-0 text-headline-sm tracking-[-0.12px] text-black-800 ${
              titleWeight === 'semibold' ? 'font-semibold' : 'font-medium'
            }`}
          >
            {title}
          </p>
          {description !== undefined && description.length > 0 && (
            <p className="m-0 text-body-md text-black-300">{description}</p>
          )}
        </div>
      </div>

      <img
        className="block h-[228px] w-full max-w-[343px] object-contain object-left"
        src="/illust/org-register-done.png"
        alt=""
      />

      {children}
    </section>
  )
}
